import { render, staticRenderFns } from "./CatalogEmotionImage.vue?vue&type=template&id=64b6b9e7"
import script from "./CatalogEmotionImage.vue?vue&type=script&lang=ts"
export * from "./CatalogEmotionImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports